export default __webpack_public_path__ + "static/SMI-demo-dcb045b481bb716de1f6a30d784eecdd.webp";